export default [
  { value: "", text: "" },
  { value: "short", text: "Short" },
  { value: "long", text: "Long" }
];
